import client from './client';
import qs from 'qs';

const kpiUrl = '/api/v1/kpi';

export const getProductionKpi = (params) =>
  client.get(`${kpiUrl}/production?${qs.stringify(params)}`);

export const getQualityKpi = (params) =>
  client.get(`${kpiUrl}/quality?${qs.stringify(params)}`);

export const getProcessDefectKpi = (params) =>
  client.get(`${kpiUrl}/process-defect?${qs.stringify(params)}`);

export const getDeliveryKpi = (params) =>
  client.get(`${kpiUrl}/delivery?${qs.stringify(params)}`);

export const getLeadTimeKpi = (params) =>
  client.get(`${kpiUrl}/lead-time?${qs.stringify(params)}`);

export const getEqpCostKpi = (params) =>
  client.get(`${kpiUrl}/eqp-cost?${qs.stringify(params)}`);

export const getHrUtilKpi = (params) =>
  client.get(`${kpiUrl}/hr-util?${qs.stringify(params)}`);

export const getPurchaseKpi = (params) =>
  client.get(`${kpiUrl}/purchase?${qs.stringify(params)}`);

// 메인 대시보드 PQCD 게이지 전용 - 계약~출하 리드타임(납기 단축률)
export const getContractLeadKpi = (params) =>
  client.get(`${kpiUrl}/contract-lead?${qs.stringify(params)}`);

// 메인 대시보드 PQCD 게이지 전용 - 재공재고 스냅샷(asOfDt 시점, KPI_WIP_INF 대신 생산계획에서 계산)
export const getWipSnapshot = (params) =>
  client.get(`${kpiUrl}/wip-snapshot?${qs.stringify(params)}`);
